export default __webpack_public_path__ + "static/media/pagenine.bff32b07.txt";